import { useCallback, useState } from 'react';

export const useMap = ({
  initialValue = {},
} = {}) => {
  const [map, setMap] = useState(initialValue);
  const setValue = useCallback(
    (
      key,
      value,
    ) => setMap((state) => ({ ...state, [key]: value })),
    [],
  );

  return {
    map,
    setValue,
    setValues: setMap,
  };
};
